import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-coming-soon',
  templateUrl: './recent-licenses.component.html',
  styleUrls: ['./recent-licenses.component.css']
})
export class RecentLicensesComponent implements OnInit {
  private title: string = '';

  constructor(private route: ActivatedRoute) {
    if (this.route.snapshot.data['title']) {
      this.title = this.route.snapshot.data['title'];
    }
  }

  ngOnInit() {
      localStorage.setItem("radio",'0');
  }

}



// WEBPACK FOOTER //
// ./src/app/recent-licenses/recent-licenses.component.ts